import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contact-list-container" }
const _hoisted_2 = { class: "contact-table" }
const _hoisted_3 = { class: "item-contact" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "select" }
const _hoisted_6 = { class: "select-border checkbox" }
const _hoisted_7 = { class: "item-contact" }
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { class: "item-mail" }
const _hoisted_10 = { class: "buttons-container" }
const _hoisted_11 = ["onClick", "src"]
const _hoisted_12 = ["onClick", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_bordered_icon_button = _resolveComponent("bordered-icon-button")!
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
            _createElementVNode("th", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t('contactSelection.table.contact')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "demandeIntervention.contactsSuivi" })
            ]),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('contactSelection.table.mail')), 1),
            _cache[1] || (_cache[1] = _createElementVNode("th", { class: "buttons-container" }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
            return (_openBlock(), _createElementBlock("tr", {
              onClick: ($event: any) => (_ctx.toggleSelect(contact)),
              key: `${contact.email}`
            }, [
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CheckBox, {
                    checked: _ctx.selectedContacts.map(c => c.email).includes(contact.email),
                    label: ""
                  }, null, 8, ["checked"])
                ])
              ]),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(`${contact.firstname} ${contact.lastname.toUpperCase()}`), 1)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(contact.email), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    onClick: _withModifiers(($event: any) => (_ctx.openEdit(contact)), ["stop"]),
                    src: _ctx.getEditIcon,
                    class: "icon icon-edit",
                    alt: "Edit Contact"
                  }, null, 8, _hoisted_11),
                  (_ctx.contacts.length > 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (_ctx.removeContact(contact)), ["stop"]),
                        src: _ctx.getDeleteIcon,
                        class: "icon",
                        alt: "Remove Contact"
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]),
      _createVNode(_component_bordered_icon_button, {
        isDisabled: _ctx.contacts.length > 4,
        class: "add-button",
        onClick: _ctx.openAdd,
        title: _ctx.$t('contactSelection.table.add'),
        imgUrl: _ctx.loadAddIcon
      }, null, 8, ["isDisabled", "onClick", "title", "imgUrl"])
    ]),
    (_ctx.contactModal)
      ? (_openBlock(), _createBlock(_component_ContactForm, {
          key: 0,
          onConfirm: _ctx.confirmContact,
          contact: _ctx.contactToEdit,
          onClose: _ctx.closeModal,
          isPhone: false
        }, null, 8, ["onConfirm", "contact", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}